import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createStore as createJotaiStore, Provider as JotaiProvider } from 'jotai'
import React from 'react'
import UserAnalytics from 'src/components/UserAnalytics/UserAnalytics'
import { setAppInitialisedAtom } from 'src/services/app-init/app-init-atoms'

import DevTools from '../components/DevTools'
import FacebookMessenger from '../components/FacebookMessenger/FacebookMessenger'
import GnattaWeb from '../components/GnattaWebchat/GnattaWebchat'
import ResponseTap from '../components/ResponseTap/ResponseTap'
import SiteScripts from '../components/SiteScripts/SiteScripts'

import AppWrapper from './AppWrapper'
import { initAppInsights } from './app-insights'


const StoreProvider = ({ element }: { element: React.ReactNode }) => {
  // Fresh Jotai store per render (called in the `wrapRootElement` handler): a new store for each
  // SSR page, and once in the browser when React mounts. Client state is fully on Jotai (Redux
  // + the ReduxAtomBridge have been removed); server state stays on React Query.
  // Never use Jotai's default global store here — SSR page state must stay isolated.
  const jotaiStore = createJotaiStore()

  // TODO think about integrating history track by react app insights lib
  if (process.env.GATSBY_ENV === 'production') initAppInsights()

  // app init — set the Jotai flag directly (app-init is fully on atoms; no Redux/saga)
  jotaiStore.set(setAppInitialisedAtom)
  // Create a client
  const queryClient = new QueryClient()

  return (
    <UserAnalytics>
      <QueryClientProvider client={queryClient}>
        <JotaiProvider store={jotaiStore}>
          <ResponseTap />
          {/* keep AppWrapper as the first child !!! */}
          <AppWrapper>{element}</AppWrapper>
          <SiteScripts />
          <FacebookMessenger />
          <GnattaWeb />
          <DevTools />
        </JotaiProvider>
      </QueryClientProvider>
    </UserAnalytics>
  )
}

export default StoreProvider
